import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Appeal from './pages/Appeal';
import AppealHistory from './pages/AppealHistory';
import AppealDetail from './pages/AppealDetail';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/appeal" element={<Appeal />} />
        <Route path="/appeal-history" element={<AppealHistory />} />
        <Route path="/appeal-detail/:id" element={<AppealDetail />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
